export const BASE_URL = '/api'
export const AUTHENTICATE = BASE_URL + '/login'
export const CONFIGURATION = BASE_URL + '/setup';
export const EPP_CONFIGURATION = BASE_URL + '/config/epp'
export const ADMIN_POLLING = BASE_URL + '/config/epp/pollreq'
export const EPP_PASSWORD = BASE_URL + '/config/epp/password';
export const ADMIN_EMAIL = BASE_URL + '/config/mail'
export const ADMIN_EPP = BASE_URL + '/config/epp'
export const SETUP_USER = BASE_URL + '/setup/user'
